import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button', 'panel'];
  static values = { activeTab: String };

  connect() {
    if (!this.hasActiveTabValue) this.activeTabValue = 'list';
    this.render();
  }

  show(event) {
    event.preventDefault();
    this.activeTabValue = event.currentTarget.dataset.tab;
  }

  activeTabValueChanged() {
    this.render();
  }

  render() {
    this.buttonTargets.forEach((button) => {
      const isActive = button.dataset.tab === this.activeTabValue;
      button.parentElement.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.tab !== this.activeTabValue);
    });
  }
}
